import React, { useEffect, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthContext, API } from "@/App";
import { toast } from "sonner";

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useContext(AuthContext);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL hash
      const hash = location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      
      if (!match) {
        toast.error("Authentication failed");
        navigate("/login");
        return;
      }

      const sessionId = match[1];

      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId })
        });

        if (res.ok) {
          const data = await res.json();
          setUser(data.user);
          toast.success("Welcome!");
          // Navigate to dashboard with user data to skip auth check
          navigate("/dashboard", { state: { user: data.user }, replace: true });
        } else {
          const error = await res.json();
          toast.error(error.detail || "Authentication failed");
          navigate("/login");
        }
      } catch (e) {
        console.error("Auth callback error:", e);
        toast.error("Authentication failed");
        navigate("/login");
      }
    };

    processAuth();
  }, []);

  return (
    <div className="min-h-screen bg-obsidian flex flex-col items-center justify-center">
      <Loader2 className="w-10 h-10 text-primary animate-spin mb-4" />
      <p className="text-white/60">Completing sign in...</p>
    </div>
  );
};

export default AuthCallback;
